import React, { useEffect, useState } from "react";
import Headar from "../Component/Headar";
import MobileHader from "../Component/MobileHader";
import BradCrum from "../Component/BradCrum";
import ShapeImg from "../aseets/img/curve.png";
import BlogImg1 from "../aseets/img/banner2.png";
import { FaAnglesRight } from "react-icons/fa6";

import Footer from "../Component/Footer";
import PlatinumFamily from "../Component/PlatinumFamily";
import "../Css/Blog.css";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";

const Blog = () => {
  const blogData = [
    {
      img: BlogImg1,
      title: "Text will be comming soon...",
      description:
        "Text will be comming soon...Text will be comming soon...",
    },
    {
      img: BlogImg1,
      title: "Text will be comming soon...",
      description:
       "Text will be comming soon...Text will be comming soon...",
    },
    {
      img: BlogImg1,
      title: "Text will be comming soon...",
      description:
     "Text will be comming soon...Text will be comming soon...",
    },
    {
      img: BlogImg1,
      title: "Text will be comming soon...",
      description:
       "Text will be comming soon...Text will be comming soon...",
    },
    {
      img: BlogImg1,
      title: "Text will be comming soon...",
      description:
        "Text will be comming soon...Text will be comming soon...",
    },
    {
      img: BlogImg1,
      title: "Text will be comming soon...",
      description:
      "Text will be comming soon...Text will be comming soon...",
    },
  ];
  const [bannerImages, setBannerImages] = useState({});
  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/list/inner-banners`);
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          setBannerImages(response.data); 
          
        }
      } catch (error) {
        console.error('Error fetching banner images:', error);
      }
    };

    fetchBannerImages();

    
  }, []);
  return (
    <React.Fragment>
      <Headar />
      <MobileHader />
      <BradCrum
        Title={bannerImages[0]?.Title}
        BradCrumImg={`${process.env.REACT_APP_API_URL}/${bannerImages[0]?.bannerImage}`}
        ShapeImg={ShapeImg}
        color="#fff"
      />
      <Container className="blogContainer">
        <Row>
          <Col lg={9} md={9}>
            <Row>
              {blogData?.map((data) => (
                <Col lg={4} md={6}>
                  <Card className="blogCard">
                    <img src={data.img} alt="img" />
                    <div className="dateDiv">{data.title}</div>
                    <div className="blogDescription">{data.description}</div>
                    <Link className="readMorelink" to="#">
                      Read More <FaAnglesRight />
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
          <Col lg={3} md={3}>
            <div className="blogCategoryTitle">Categories</div>
            <div className="cateoryLinkDiv">
              <Link className="catetoryLink" to="#">
              <FaAnglesRight />  Categori one
              </Link>
            </div>
            <div className="cateoryLinkDiv">
              <Link className="catetoryLink" to="#">
              <FaAnglesRight />  Categori two
              </Link>
            </div>{" "}
            <div className="cateoryLinkDiv">
              <Link className="catetoryLink" to="#">
              <FaAnglesRight /> Categori three
              </Link>
            </div>{" "}
            <div className="cateoryLinkDiv">
              <Link className="catetoryLink" to="#">
              <FaAnglesRight />   Categori foure
              </Link>
            </div>{" "}
            <div className="cateoryLinkDiv">
              <Link className="catetoryLink" to="#">
              <FaAnglesRight />   Categori five
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
      <PlatinumFamily />
      <Footer />
    </React.Fragment>
  );
};

export default Blog;
